<template>
  <v-layout>
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>
        <!--sale stats begin-->
        <v-flex xs12 sm4>
          <v-card>
            <v-card-title primary-title style="background:darkgreen;color: white;">
              <div>
                <h4 class="headline mb-0">Revenue</h4>
              </div>
            </v-card-title>
            <!--<v-divider></v-divider>-->
            <v-card-text style="background:darkgreen;color: white;">
              <v-layout row wrap class="stat-data">
                <v-flex xs4>
                  <v-icon style="color: white">swap_horizontal</v-icon>
                </v-flex>

                <v-flex
                  xs8
                  style="font-size:25px"
                >GHS {{revenue_data?revenue_data.cash_sale_sum+revenue_data.credit_sale_sum:0 | currency}}</v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <p>Total Revenue Today</p>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4>
          <v-card>
            <v-card-title primary-title style="background:#626f78;color: white;">
              <div>
                <h4 class="headline mb-0">Credit Sale</h4>
              </div>
            </v-card-title>
            <!--<v-divider></v-divider>-->
            <v-card-text style="background:#626f78;color: white;">
              <v-layout row wrap class="stat-data">
                <v-flex xs4>
                  <v-icon style="color: white">money</v-icon>
                </v-flex>

                <v-flex
                  xs8
                  style="font-size:25px"
                >GHS {{revenue_data?revenue_data.credit_sale_sum:0 | currency}}</v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <p>Total Credit Sales Today</p>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4>
          <v-card>
            <v-card-title primary-title style="background:darkred;color: white;">
              <div>
                <h4 class="headline mb-0">Expenses</h4>
              </div>
            </v-card-title>
            <!--<v-divider></v-divider>-->
            <v-card-text style="background:darkred;color: white;">
              <v-layout row wrap class="stat-data">
                <v-flex xs4>
                  <v-icon style="color: white">money</v-icon>
                </v-flex>

                <v-flex
                  xs8
                  style="font-size:25px"
                >GHS {{expenses_data?expenses_data.ov_expense:0 | currency}}</v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <p>Total Expenses Today</p>
            </v-card-actions>
          </v-card>

        </v-flex>

        <!-- <v-flex xs12 sm4>
          <v-card>
            <v-card-title primary-title style="background:darkblue;color: white;">
              <div>
                <h4 class="headline mb-0">Items</h4>
              </div>
            </v-card-title>
        
            <v-card-text style="background:darkblue;color: white;">
              <v-layout row wrap class="stat-data">
                <v-flex xs4>
                  <v-icon style="color: white">list</v-icon>
                </v-flex>

                <v-flex xs8>{{other_vals.total_stock_items}}</v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <p>Total Items In Stock</p>
            </v-card-actions>
          </v-card>
        </v-flex>-->
      </v-layout>
      <!--sale stats end-->

      <v-layout row wrap>

        <v-flex class="xs12">
          <div style="page-break-after: always;">
            <h3 style="text-align:center">Vendor Sale Summaries Today</h3>
            <v-data-table
              :headers="vendor_sale_headers"
              :items="revenue_data.vendor_sale_sums?revenue_data.vendor_sale_sums:[]"
              class="elevation-1 mb-4"
              :disable-pagination="true"
              :hide-default-footer="true"
              :loading="rloading"
            >
              <!-- <template v-slot:items="props">
                <td class="text-xs-center">{{ props.index+1 }}</td>
                <td class="text-xs-center">{{ props.item.vendor }}</td>
                <td class="text-xs-center">{{ props.item.cs | currency}}</td>
                <td class="text-xs-center">{{ props.item.crs | currency}}</td>
              </template> -->

                <template v-slot:item.sn="{ item,index }">
                  {{ index+1 }}
                </template>
                  <template v-slot:item.cs="{ item }">
                  {{ parseFloat(item.cs) | currency }}
                </template>
                  <template v-slot:item.crs="{ item }">
                  {{ parseFloat(item.crs) | currency }}
                </template>
            </v-data-table>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-layout>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      moment: moment,
      vendor_sale_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "sn"
        },
        {
          text: "Vendor",
          align: "center",
          sortable: false,
          value: "vendor"
        },
        {
          text: "Cash Sale Sum (GHS)",
          align: "center",
          sortable: false,
          value: "cs"
        },
        {
          text: "Credit Sale Sum (GHS)",
          align: "center",
          sortable: false,
          value: "crs"
        }
      ],
      report_model: {
        rpt_type: "",
        from: "",
        to: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      revenue: "Reports/REVENUE",
      expenses: "Reports/EXPENSES",
      revenue_data: "Reports/REVENUE_DATA",
      expenses_data: "Reports/EXPENSES_DATA",
      rerrors: "Reports/REPORT_ERROR",
      rloading: "Reports/REPORT_LOADING"
    })
  },
  created() {
    this.generateRpt();
  },
  methods: {
    async generateRpt() {
      await this.$store.dispatch("Reports/getRpt", this.report_model);
    }
  }
};
</script>